import styles from './Flag.module.css'

interface FlagProps {
    /** ISO 3166-1 alpha-2, any case. */
    cc?: string
    /** Full country name; this is what carries the meaning. */
    name?: string
}

/**
 * The flag image is decorative and gets alt="" -- the country name beside it is
 * the information. The old UI used the two-letter code as alt text, so screen
 * readers announced "TR" with no context.
 */
export default function Flag({ cc, name }: FlagProps) {
    const code = cc?.toLowerCase()
    // only a real alpha-2 code has a flag file. geoip returns "-" when it cannot
    // place an address, and requesting /flags/-.png just 404s.
    const hasFlag = code !== undefined && /^[a-z]{2}$/.test(code)
    return (
        <span className={styles.wrap}>
            {hasFlag && <img className={styles.img} src={`/flags/${code}.png`} alt="" width={24} height={16} loading="lazy" />}
            <span>{name ?? cc ?? '—'}</span>
        </span>
    )
}
